import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { SessionData } from '@/shared/types/session';

import {
    googleFulfilledMatcher,
    signInFulfilledMatcher,
} from '../../api/auth.api';
import type { SessionSchema } from '../types/session.schema';

const initialState: SessionSchema = {
    isAuthorized: false,
    accessToken: undefined,
    refreshToken: undefined,
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        clear: (state) => {
            state.accessToken = undefined;
            state.refreshToken = undefined;
            state.isAuthorized = false;
        },
        reset: (
            state,
            action: PayloadAction<Pick<SessionData, 'access' | 'refresh'>>,
        ) => {
            state.accessToken = action.payload.access;
            state.refreshToken = action.payload.refresh;
        },
    },
    extraReducers: (builder) =>
        builder
            .addMatcher(signInFulfilledMatcher, (state, action) => {
                state.isAuthorized = true;
                state.accessToken = action.payload.access;
                state.refreshToken = action.payload.refresh;
            })
            .addMatcher(googleFulfilledMatcher, (state, action) => {
                state.isAuthorized = true;
                state.accessToken = action.payload.access;
                state.refreshToken = action.payload.refresh;
            }),
});

export const { actions: sessionActions, reducer: sessionReducer } =
    sessionSlice;
